import { userAgentParser } from '@common/UserAgentParser/UserAgentParser'

/**
 * Ez egy Android eszköz, vagy CORDOVA-val buildelünk?
 * @param ua - UserAgent.
 */
export default function isAndroid (ua: string): boolean {
  return userAgentParser.isAndroid(ua)
}
